module.exports = __webpack_public_path__ + "static/Auto-Share-7-e1407759069481-aaf3ea1de41c26a1a99d6ebaf75a84e9.jpg";